import { apiUrl } from "../taskpane";

const parseResponse = async (response) => {
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const message = data?.detail || "Request failed";
    const error = new Error(message);
    error.status = response.status;
    error.body = data;
    throw error;
  }
  return data;
};

export async function fetchCustomers(token) {
  const res = await fetch(apiUrl("customers"), {
    headers: { Authorization: `Bearer ${token}` },
  });
  return parseResponse(res);
}

export async function createCustomer(token, data) {
  const res = await fetch(apiUrl("customers"), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(data),
  });
  return parseResponse(res);
}

export async function updateCustomer(token, customerId, data) {
  const res = await fetch(apiUrl(`customers/${customerId}`), {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(data),
  });
  return parseResponse(res);
}

export async function deleteCustomer(token, customerId) {
  const res = await fetch(apiUrl(`customers/${customerId}`), {
    method: "DELETE",
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok && res.status !== 204) {
    const data = await res.json().catch(() => ({}));
    const error = new Error(data?.detail || "Delete failed");
    error.status = res.status;
    throw error;
  }
  return true;
}
